import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleLogout = () => {
      setUser(null);
    };
    window.addEventListener('auth:logout', handleLogout);
    return () => window.removeEventListener('auth:logout', handleLogout);
  }, []);

  useEffect(() => {
    // localStorage'dan başa, session'a geç
    let token = localStorage.getItem('token');
    let stored = localStorage.getItem('user');
    
    // Her ikisi de localStorage'da yoksa, sessionStorage'dan dene
    if (!token && !stored) {
      if (typeof sessionStorage !== 'undefined') {
        token = sessionStorage.getItem('token');
        stored = sessionStorage.getItem('user');
      }
    }
    
    // Token ve user varsa user'ı set et
    if (token && stored) {
      try {
        const userData = JSON.parse(stored);
        setUser(userData);
      } catch (e) {
        console.error('Failed to parse user from storage:', e);
        // Parse hatası varsa, token'ları sil
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password, rememberMe = false) => {
    try {
      const res = await authService.login(email, password);
      const { token, user: u } = res.data;
      if (rememberMe) {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(u));
      } else {
        if (typeof sessionStorage !== 'undefined') {
          sessionStorage.setItem('token', token);
          sessionStorage.setItem('user', JSON.stringify(u));
        }
      }
      setUser(u);
      return u;
    } catch (error) {
      console.error('AuthContext login error:', error);
      throw error;
    }
  };

  const logout = () => {
    authService.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};